import { useAtom } from "jotai";
import { recordedAtom } from "../atoms/recordedAtoms";
import { Recording } from "@quantizr-engineering/common/types/recording";
import apiClient from "./apiClient";
import { FIVE_MINUTES_MS } from "../utils/consts";
import { useEffect } from "react";
import { toast } from "sonner";

export const useRecordedService = () => {
  const [recorded, setRecorded] = useAtom(recordedAtom);

  useEffect(() => {
    cacheGetRecorded();
  }, []);

  const getRecorded = async () => {
    setRecorded((prev) => ({ ...prev, loading: true }));

    try {
      const response = await apiClient.get("/release/all", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      });
      setRecorded((prev) => ({
        loading: false,
        data: response.data,
        lastFetched: Date.now(),
      }));
      return response.data;
    } catch (error) {
      setRecorded((prev) => ({
        ...prev,
        loading: false,
        data: [],
        lastFetched: null,
      }));
      throw error;
    }
  };

  const cacheGetRecorded = async () => {
    if (!!recorded.loading) {
      return;
    }
    if (
      !recorded.lastFetched ||
      Date.now() - recorded.lastFetched > FIVE_MINUTES_MS
    ) {
      await getRecorded();
    }
  };

  const postRecording = async (recording: Recording) => {
    try {
      const response = await apiClient.post("/recording", recording, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      });
      await getRecorded();
      toast.success("Recording added");
      return response;
    } catch (error) {
      throw error;
    }
  };

  const patchRecording = async (recording: Recording) => {
    try {
      const response = await apiClient.patch(
        `/recording/${recording.id}`,
        recording,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );
      await getRecorded();
      toast.success("Updated recording");
      return response;
    } catch (error) {
      toast.error("Failed to update recording");
      throw error;
    }
  };

  return {
    recorded: recorded.data,
    recordedLoading: recorded.loading,
    getRecorded: getRecorded,
    cacheGetRecordings: cacheGetRecorded,
    postRecording,
    patchRecording,
  };
};
